import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  MenuItem,
  tableCellClasses,
  Typography,
  Popover,
  Box,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Progress } from "antd";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import AxiosInstance from "../components/Axios";
import colors from "../components/constants/Colors";
import { ModeEditOutlined } from "@mui/icons-material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.primary,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: { fontSize: 14 },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:last-child td, &:last-child th": { border: 0 },
}));

export default function OnlineMetrics() {
  const [onlineMetrics, setOnlineMetrics] = useState([]);
  const [columnsMetrics, setColumnsMetrics] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newCurrentCounts, setNewCurrentCounts] = useState({});
  const [reportingPeriods, setReportingPeriods] = useState([]);
  const [selectedPeriods, setSelectedPeriods] = useState({});
  const [selectedReportingPeriod, setSelectedReportingPeriod] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const project_id = localStorage.getItem("project_id");
  const role = localStorage.getItem("role");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedMetrics = onlineMetrics.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      title: {
        text: "Online Metrics",
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        labels: {
          style: {
            fontWeight: "bold",
          },
        },
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}`,
        },
      },
      fill: {
        opacity: 0.7,
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
    },
  });

  useEffect(() => {
    if (onlineMetrics.length > 0 && columnsMetrics.length > 0) {
      const seriesData = [];
      const categories = [];

      onlineMetrics.forEach((row) => {
        console.log("Platform:", row.platform);

        categories.push(row.platform);

        columnsMetrics.forEach((metric) => {
          console.log("Metric:", metric);

          let totalCurrentCount = 0;
          // Calculer la somme des current_count pour chaque RP dans la métrique
          Object.keys(row.metrics[metric]?.current_count || {}).forEach(
            (rp) => {
              const currentCount =
                parseInt(row.metrics[metric].current_count[rp], 10) || 0;
              totalCurrentCount += currentCount;
              console.log(
                `RP: ${rp}, Current Count: ${currentCount}, Total Current Count: ${totalCurrentCount}`
              );
            }
          );

          if (!seriesData[metric]) {
            seriesData[metric] = [];
          }
          seriesData[metric].push(totalCurrentCount);
        });
      });

      console.log("Aggregated Series Data:", seriesData);
      console.log("Categories:", categories);

      // Transformer les données en format attendu par ApexChart
      const series = Object.keys(seriesData).map((metric) => ({
        name: metric,
        data: seriesData[metric],
      }));

      // Mettre à jour les données du graphique avec les séries et catégories
      setChartData((prevState) => ({
        ...prevState,
        series,
        options: {
          ...prevState.options,
          xaxis: {
            ...prevState.options.xaxis,
            categories,
          },
        },
      }));
    }
  }, [onlineMetrics, columnsMetrics]);

  useEffect(() => {
    fetchMetrics();
    fetchReportingPeriods();
  }, []);

  const fetchMetrics = async () => {
    try {
      const { data } = await AxiosInstance.get(
        `/projects/${project_id}/metrics`
      );
      if (data.length > 0) {
        setOnlineMetrics(data);
        const allMetrics = [
          ...new Set(data.flatMap((item) => Object.keys(item.metrics))),
        ];
        setColumnsMetrics(allMetrics);
        console.log("data is", data);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des métriques en ligne :",
        error
      );
    }
  };

  const fetchReportingPeriods = async () => {
    try {
      const { data } = await AxiosInstance.get("get-rp-counts/");
      const allReportingPeriods = [
        ...new Set([
          ...(data.event_counts?.map((item) => item.reportingPeriod) || []),
          ...(data.social_media_counts?.map((item) => item.reportingPeriod) ||
            []),
          ...(data.website_counts?.map((item) => item.reportingPeriod) || []),
        ]),
      ];
      setReportingPeriods(allReportingPeriods);
    } catch (error) {
      console.error("Error fetching reporting periods:", error);
    }
  };

  useEffect(() => {
    const initialSelectedPeriods = onlineMetrics.reduce((acc, row, index) => {
      acc[index] = ""; // Par défaut, chaque ligne a une période vide
      return acc;
    }, {});
    setSelectedPeriods(initialSelectedPeriods);
  }, [onlineMetrics]);

  const handleOpenModal = (row) => {
    setSelectedRow(row);
    const selectedPeriod = selectedPeriods[row.id] || "";
    setNewCurrentCounts(
      columnsMetrics.reduce((acc, metric) => {
        acc[metric] = row.metrics[metric]?.current_count || {};
        return acc;
      }, {})
    );
    setOpenModal(true);
  };
  const handleInputChange = (metric, reportingPeriod, value) => {
    setNewCurrentCounts((prevCounts) => ({
      ...prevCounts,
      [metric]: {
        ...prevCounts[metric],
        [reportingPeriod]: value,
      },
    }));
  };

  const handleSaveCurrentCount = async () => {
    if (!selectedRow) {
      console.error("Missing selected row.");
      return;
    }

    const selectedReportingPeriod = selectedPeriods[selectedRow.id] || "";
    if (!selectedReportingPeriod) {
      console.error("No reporting period selected for the current row.");
      return;
    }

    const updatedMetrics = { ...selectedRow.metrics };

    columnsMetrics.forEach((metric) => {
      if (updatedMetrics[metric]) {
        updatedMetrics[metric].current_count[selectedReportingPeriod] =
          newCurrentCounts[metric]?.[selectedReportingPeriod] ?? "0";
      }
    });

    try {
      const { data } = await AxiosInstance.put(
        `/projects/${project_id}/platforms/${selectedRow.platform}/update-current-count/`,
        {
          metrics: updatedMetrics,
          reporting_period: selectedReportingPeriod,
        }
      );

      console.log("Updated metrics: ", data);
      setOpenModal(false);
      fetchMetrics();
    } catch (error) {
      console.error("Error updating metrics:", error);
    }
  };

  const getProgressColor = (calculatedValue, reachedCount) => {
    if (!calculatedValue || !reachedCount) return "#d9d9d9";
    const percentage = (calculatedValue / reachedCount) * 100;

    if (percentage < 25) return "#ff4d4f"; // Rouge (< 25%)
    if (percentage < 50) return "#ff9800"; // Orange (25% - 50%)
    if (percentage < 100) return "#ffec3d"; // Jaune (50% - 100%)
    return "#52c41a"; // Vert (100% et +)
  };

  const getCurrentCountForSelectedPeriod = (
    currentCounts = {},
    reachedCount = 0,
    selectedPeriod = ""
  ) => {
    if (!currentCounts || typeof currentCounts !== "object") {
      console.error(
        "getCurrentCountForSelectedPeriod received invalid currentCounts:",
        currentCounts
      );
      return { totalCurrentCount: 0, percentage: 0, color: "#d9d9d9" };
    }

    const totalCurrentCount =
      selectedPeriod === ""
        ? Object.values(currentCounts).reduce(
            (sum, val) => sum + (parseInt(val) || 0),
            0
          )
        : parseInt(currentCounts[selectedPeriod]) || 0;

    if (totalCurrentCount === 0) {
      return { totalCurrentCount, percentage: 0, color: "#d9d9d9" }; // Gray color for empty bar
    }

    const percentage =
      reachedCount > 0
        ? Math.min((totalCurrentCount / reachedCount) * 100, 100)
        : 0;
    const color = getProgressColor(totalCurrentCount, reachedCount);

    return { totalCurrentCount, percentage, color };
  };

  const handlePeriodChange = (rowId, period) => {
    setSelectedPeriods((prev) => ({
      ...prev,
      [rowId]: period,
    }));
  };

  return (
    <div>
      <TableContainer sx={{ width: "100%" }} component={Paper}>
        <Table sx={{ minWidth: 700 }}>
          <TableHead
            sx={{ filter: columnsMetrics.length === 0 ? "blur(4px)" : "none" }}
          >
            <TableRow>
              <StyledTableCell>Platform</StyledTableCell>
              <StyledTableCell>RP</StyledTableCell>
              {columnsMetrics.map((metric) => (
                <StyledTableCell style={{ width: 300 }} key={metric}>
                  {metric}
                </StyledTableCell>
              ))}
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {columnsMetrics.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={columnsMetrics.length + 3}
                  style={{ textAlign: "center", fontStyle: "italic" }}
                >
                  There is no metrics available
                </TableCell>
              </TableRow>
            ) : (
              paginatedMetrics.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>{row.platform}</StyledTableCell>
                  <StyledTableCell>
                    <Select
                      value={selectedPeriods[row.id] || ""}
                      onChange={(e) =>
                        handlePeriodChange(row.id, e.target.value)
                      }
                      displayEmpty
                      sx={{ minWidth: 70 }}
                    >
                      <MenuItem value="">All</MenuItem>
                      {reportingPeriods
                        .sort((a, b) => a.localeCompare(b))

                        .map((period) => (
                          <MenuItem key={period} value={period}>
                            {period}
                          </MenuItem>
                        ))}
                    </Select>
                  </StyledTableCell>
                  {columnsMetrics.map((metric) => (
                    <StyledTableCell key={metric}>
                      {row.metrics[metric] ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {(() => {
                            const currentCounts =
                              row.metrics[metric].current_count;
                            const reachedCount =
                              row.metrics[metric].reached_count;
                            const { totalCurrentCount, percentage, color } =
                              getCurrentCountForSelectedPeriod(
                                currentCounts,
                                reachedCount,
                                selectedPeriods[row.id] || ""
                              );
                            return (
                              <>
                                <div style={{ width: 100 }}>
                                  <Progress
                                    percent={percentage}
                                    size="small"
                                    strokeColor={color}
                                    showInfo={false}
                                  />
                                </div>
                                <span style={{ fontSize: "11px" }}>
                                  {totalCurrentCount === 0
                                    ? `${totalCurrentCount} / ${reachedCount} ${metric}`
                                    : `${totalCurrentCount} / ${reachedCount} ${metric}`}
                                </span>
                              </>
                            );
                          })()}
                        </div>
                      ) : (
                        <Box
                          sx={{
                            display: "inline-block",
                            filter: "blur(2px)",
                            cursor: "pointer",
                          }}
                          onMouseEnter={handlePopoverOpen}
                          onMouseLeave={handlePopoverClose}
                        >
                          To define !
                        </Box>
                      )}
                    </StyledTableCell>
                  ))}
                  <StyledTableCell>
                    <IconButton
                      disabled={!selectedPeriods[row.id]}
                      style={{
                        display:
                          role !== "moderator" && role !== "coordinator"
                            ? "none"
                            : "flex",
                      }}
                      onClick={() => handleOpenModal(row)}
                    >
                      <ModeEditOutlined />
                    </IconButton>
                    <Popover
                      id="mouse-over-popover"
                      sx={{ pointerEvents: "none" }}
                      open={open}
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      onClose={handlePopoverClose}
                      disableRestoreFocus
                    >
                      <p sx={{ fontSize: 11 }}>
                        Platform does not contain this metric. If you want to
                        add it, please go to 'Variables'
                      </p>
                    </Popover>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[3, 10, 25]}
        component="div"
        count={onlineMetrics.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/* Dialog for editing */}

      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Edit Metrics</DialogTitle>
        <br />
        <DialogContent>
          {columnsMetrics.map((metric) => {
            const metricData = selectedRow?.metrics[metric];
            if (metricData) {
              return (
                <div key={metric}>
                  <TextField
                    style={{ marginBottom: 20 }}
                    label={`Current Count - ${metric}`}
                    value={
                      newCurrentCounts[metric]?.[
                        selectedPeriods[selectedRow.id]
                      ] || ""
                    }
                    onChange={(e) =>
                      handleInputChange(
                        metric,
                        selectedPeriods[selectedRow.id],
                        e.target.value
                      )
                    }
                    fullWidth
                  />
                </div>
              );
            } else {
              return null;
            }
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveCurrentCount} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
